import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CheckmarkIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 9L8.5 13L16.5 5" stroke="currentColor" strokeWidth="2" />
  </svg>,
  'Checkmark'
);
